import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'

import FieldLabel from '../../../../components/FieldLabel/FieldLabel'
import BasicInput from '../../../../components/InputField/BasicInput'
import {Breakpoint} from '../../../../types/constEnums'
import {NewTeamFieldBlock} from './NewTeamForm'
import NewTeamFormBlock from './NewTeamFormBlock'

const FormBlockInline = styled(NewTeamFormBlock)({
  marginTop: 16,
  [`@media screen and (min-width: ${Breakpoint.SIDEBAR_LEFT}px)`]: {
    marginTop: 48
  }
})









const NewTeamFormTeamName = (props) => {
  const {error, onChange, teamName, disabled, autoFocus} = props
  return (
    _jsxs(FormBlockInline, { children: [
      _jsx(FieldLabel, { fieldSize: "medium", htmlFor: "teamName", indent: true, inline: true, label: "Team Name" ,} )
      , _jsx(NewTeamFieldBlock, { children: 
        _jsx(BasicInput, {
          autoFocus: autoFocus,
          disabled: disabled,
          error: error,
          name: "teamName",
          onChange: onChange,
          value: teamName,}
        )
      })
    ]})
  )
}

export default NewTeamFormTeamName
